import { Card, CardBody, CardHeader, Typography } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";

import { getDashboard } from "../../services/dashboard/dashboard";
import { getPersonRole } from "../../services/user/login";
import { LoadingOverlay } from "../system/loading_overlay";
import { Toaster } from "../../helper/Toaster";

import persianNumberFormat from "../../helper/PersianNumberFormat";
import TodayServicesDashboard from "./today_services_dashboard";
import ServicesDashboard from "./services_dashboard";
import SupportSalesDashboard from "./support_sales_dashboard";

const SALES_DASHBOARD_ROLES = new Set([1, 4, 5]);

export function Dashboard() {
  const [roleID, setRoleID] = useState(null);
  const [todayWorksDashboard, setTodayWorksDashboard] = useState(null);
  const [worksDashboard, setWorksDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatedAt, setUpdatedAt] = useState("");

  useEffect(() => {
    let active = true;

    async function getData() {
      try {
        // The session can have several available roles; use the active role
        // supplied by the server instead of the local list of account roles.
        const roleResponse = await getPersonRole();
        const role = Number(roleResponse?.data?.role_id);
        if (roleResponse?.status !== 200 || !Number.isInteger(role) || role < 1) {
          throw new Error("خطا در دریافت نقش حساب کاربری");
        }
        if (!active) return;
        setRoleID(role);

        // Staff load only the new summary. Skip both legacy analytics APIs.
        if (SALES_DASHBOARD_ROLES.has(role)) return;

        const response = await getDashboard();
        if (response?.status !== 200) {
          throw new Error(response?.data?.message || "خطا در دریافت اطلاعات");
        }
        if (!active) return;

        setTodayWorksDashboard(response.data.TodayWorksDashboardStatistic);
        setWorksDashboard(response.data.WorksDashboardStatistic);
        const timePart = response.data.updated_at?.split(" ")[1] || "";
        setUpdatedAt(persianNumberFormat(timePart));
      } catch (err) {
        if (active) {
          Toaster.failure(null, <Typography variant="small">
            {err.message || "خطا در دریافت اطلاعات"}
          </Typography>);
        }
      } finally {
        if (active) setLoading(false);
      }
    }

    getData();
    return () => { active = false; };
  }, []);

  const salesDashboard = SALES_DASHBOARD_ROLES.has(roleID);
  const from = roleID === 2 ? "agent" : "person";

  if (salesDashboard) return <SupportSalesDashboard />;

  return (
    <div className="w-full gap-y-8">
      <Card className="pt-8 w-full bg-blue-gray-800">
        <CardHeader floated={true} shadow={false} className="bg-blue-gray-800">
          <div className="mb-8 flex flex-col items-start justify-between md:flex-row">
            <Typography variant="h2" color="white">
              داشبورد
            </Typography>
            {updatedAt && (
              <Typography variant="h5" color="white">{`به‌روزرسانی: ${updatedAt}`}</Typography>
            )}
          </div>
        </CardHeader>


        {loading && <LoadingOverlay />}

        <CardBody className="overflow-x-auto w-full">
          {todayWorksDashboard && (
            <TodayServicesDashboard todayServices={todayWorksDashboard} from={from} />
          )}
          {worksDashboard && <ServicesDashboard works={worksDashboard} from={from} />}
        </CardBody>
      </Card>
    </div>
  );
}

export default Dashboard;
